import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

const RequireOperator = () => {
  const { isOperator, loading } = useAuth();
  if (loading) {
    return <LoadingOverlay fullscreen />;
  }

  if (!isOperator) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default RequireOperator;
